import React, { FC, Fragment } from "react";
import "./CustomPaginationTable.scss";
import Typhography from "../Typhography/Typhography";
import { EndpointWithPagination } from "../../typings/Pagination";
import classNames from "classnames";
import { CaretLeftIcon } from "@phosphor-icons/react";

interface ICustomPaginationTable {
  data?: EndpointWithPagination<any>;
  isLoading?: boolean;
  onChange?: (page: number) => void;
}

const CustomPaginationTable: FC<ICustomPaginationTable> = ({
  data,
  isLoading = false,
  onChange,
}) => {
  const onChangePage = (page: number) => () => onChange?.(page);

  if (isLoading || !data) {
    return (
      <div className={"container__pagination__table hidden"}>
        <div className="container__page" />
      </div>
    );
  }
  return (
    <div className={"container__pagination__table"}>
      {data.hasPrevPage && (
        <div className="container__page" onClick={onChangePage(data.page - 1)}>
          <CaretLeftIcon className="icon" />
        </div>
      )}
      {data.page > 3 && (
        <>
          <div
            className="container__page"
            onClick={onChangePage(1)}
          >
            <Typhography type="span" size="bold-16">
              1
            </Typhography>
          </div>
          <div className="container__page">
            <Typhography type="span" size="bold-16">
              ...
            </Typhography>
          </div>
        </>
      )}
      {Array.from({ length: 3 }, (_, i) => i + data.page - 1)
        .filter((page) => page > 0 && page <= data.totalPages)
        .map((page) => (
          <div
            key={page}
            className={classNames("container__page", {
              selected: data.page === page,
            })}
            onClick={onChangePage(page)}
          >
            <Typhography type="span" size="bold-16">
              {page}
            </Typhography>
          </div>
        ))}

      {data.page < data.totalPages - 2 && (
        <>
          <div className="container__page">
            <Typhography type="span" size="bold-16">
              ...
            </Typhography>
          </div>
          <div
            className="container__page"
            onClick={onChangePage(data.totalPages)}
          >
            <Typhography type="span" size="bold-16">
              {data.totalPages}
            </Typhography>
          </div>
        </>
      )}

      {data.hasNextPage && (
        <div className="container__page" onClick={onChangePage(data.page + 1)}>
          <CaretLeftIcon className="icon__right" />
        </div>
      )}
    </div>
  );
};

export default CustomPaginationTable;
